import {cx} from "@emotion/css";

import {designColors} from "~/ui";
import {ReactComponent as SvgFit} from "~/assets/svg/fit.svg";

import {simpleIconStyles} from "../styles";
import {commonStyles} from "../../_common/styles";
import {IIconBase} from "../../_common/types";

export const BmFitIcon: React.FC<IIconBase> = ({id, size = "sm", color = designColors.black, className}) => {
  return <SvgFit id={id} className={cx(simpleIconStyles(size), commonStyles.color(color), className)} />;
};
